import { useContext, useEffect } from 'react';
import type { Socket } from 'socket.io-client';
import { useLazyQuery } from '@apollo/client';
import { SocketContext } from '@context/socket';
import { IBlackjackLobby } from '@api/types/blackjack';
import { GET_BLACKJACK_LOBBY } from '@graphql/Queries';
import { toastErrorMessage } from '@utils/utils';
import useReduxState from '../../hooks/useReduxState';

type IReturn = [fetched: boolean, socket: Socket];

const useBlackjackLobby = (gameUid?: string): IReturn => {
  const [lobby, setBlackjack] = useReduxState((state) => state.blackjackLobby);
  const socket: Socket = useContext(SocketContext);
  const fetched: boolean = Boolean(lobby.rooms.length);

  const saveLobby = (lobby: IBlackjackLobby): void =>
    setBlackjack({
      type: 'SET_BLACKJACK_lOBBY_DATA',
      arg: lobby,
    });

  const [fetchLobby] = useLazyQuery(GET_BLACKJACK_LOBBY, {
    onCompleted: (data) => saveLobby(data.lobby),
    onError: (err: any) => toastErrorMessage(err.message),
  });

  useEffect(() => {
    fetchLobby();

    socket.emit('blackjack');
    socket.on('blackjack-lobby', saveLobby);
  }, [gameUid]);

  return [fetched, socket];
};

export default useBlackjackLobby;
